import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'

import { map } from 'rxjs'

import { FlxButtonModule, FlxFormControlModule, SelectItem } from '@flowx/angular-ui-toolkit'
import { defaultJsonEditorOptions } from '@flowx/designer/modules/monaco-code-editor/constants'
import { CodeEditorComponent } from '@flowx/designer/modules/script-builder/components/code-editor/code-editor.component'
import { JsonViewerComponent } from '@flowx/designer/shared/components/json-viewer/json-viewer.component'
import { downloadBlob, jsonToBlob } from '@flowx/shared/utils'

@Component({
  selector: 'flx-ui-flow-session-variables',
  imports: [
    CommonModule,
    JsonViewerComponent,
    FlxFormControlModule,
    FlxButtonModule,
    FormsModule,
    ReactiveFormsModule,
    CodeEditorComponent,
  ],
  templateUrl: './ui-flow-session-variables.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiFlowSessionVariablesComponent {
  variables = input<Record<string, unknown> | null | undefined>()
  sessionId = input<string | null | undefined>()
  sessionName = input<string | null | undefined>()

  viewVariablesOptions: SelectItem<string>[] = [
    { label: 'Tree View', value: 'tree' },
    { label: 'JSON view', value: 'json' },
  ]

  viewModeFC = new FormControl<SelectItem<string>>(this.viewVariablesOptions[0], {
    nonNullable: true,
  })
  viewModeValue = toSignal(this.viewModeFC.valueChanges.pipe(map((value) => value.value)), {
    initialValue: this.viewVariablesOptions[0].value,
  })

  sessionVariables = computed(() => {
    const variables = this.variables()
    if (!variables || !Object.keys(variables).length) {
      return null
    }
    return variables
  })

  stringifiedVariables = computed(() => JSON.stringify(this.sessionVariables() || {}, null, 2))
  exportFileName = computed(() => {
    const sessionName = this.sessionName()?.trim() || 'ui_flow_session'
    const sessionId = this.sessionId()?.trim() || 'variables'
    return `${sessionName}_${sessionId}`
  })
  defaultJsonEditorOptions = defaultJsonEditorOptions

  exportVariables(): void {
    downloadBlob(jsonToBlob(this.sessionVariables() || {}), this.exportFileName())
  }
}
